import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent } from '../ui/card';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';
import { Lock, KeyRound } from 'lucide-react';

export function PasswordGate({
  passwordDialogOpen,
  passwordInput,
  setPasswordInput,
  passwordError,
  onSubmit,
  onCancel,
}) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') onSubmit();
  };

  return (
    <div className="flex items-center justify-center h-64">
      <Card className="w-96">
        <CardContent className="pt-6 text-center">
          <Lock className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
          <h2 className="text-lg font-semibold">Restricted Access</h2>
          <p className="text-muted-foreground mt-2">
            Please enter the access password to continue.
          </p>
          <Button className="mt-4" onClick={() => {}}>
            <KeyRound className="w-4 h-4 mr-2" /> Enter Password
          </Button>
        </CardContent>
      </Card>
      <Dialog open={passwordDialogOpen} onOpenChange={(open) => { if (!open) onCancel(); }}>
        <DialogContent className="sm:max-w-md" onInteractOutside={(e) => e.preventDefault()}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Lock className="w-5 h-5" />
              Restricted Access
            </DialogTitle>
            <DialogDescription>
              Backup & Restore requires authorized access. Please enter the access password.
            </DialogDescription>
          </DialogHeader>
          <div className="py-4 space-y-3">
            <div>
              <Label htmlFor="backup-password">Access Password</Label>
              <Input
                id="backup-password"
                type="password"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Enter password"
                className="mt-2"
                autoFocus
                data-testid="backup-access-password"
              />
            </div>
            <p className="text-xs text-muted-foreground">
              Hint: <span className="font-mono bg-muted px-1.5 py-0.5 rounded">fov1***2(!!)</span>
            </p>
            {passwordError && (
              <p className="text-sm text-red-600">{passwordError}</p>
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={onCancel}>Cancel</Button>
            <Button onClick={onSubmit} data-testid="backup-access-submit">
              <KeyRound className="w-4 h-4 mr-2" />
              Access
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
